import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProfileStateService {
  private profileImage$ = new BehaviorSubject<string | null>(null);
  private displayName$ = new BehaviorSubject<string>('');

  profileImage = this.profileImage$.asObservable();
  displayName = this.displayName$.asObservable();

  setProfileImage(url: string | null) {
    this.profileImage$.next(url);
  }

  setDisplayName(name: string) {
    this.displayName$.next(name);
  }
}